import React, { useState, useEffect, useMemo } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { useHistory } from 'react-router-dom';

import {
    TextField,
    Typography,
    MenuItem,
    Modal,
    InputAdornment,
    Tooltip
} from '@material-ui/core';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import Swal from 'sweetalert2';

import { sha256 } from 'js-sha256';

import '../../styles/style.scss';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";

import PaymentService from '../../services/payment.service';
import usersService from '../../services/users.service';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const swalCustomButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn custom-confirm-cancel-btn',
      cancelButton: 'btn custom-cancel-btn me-3'
    },
    buttonsStyling: false
  });

export const AdvancePaymentScreen = () => {

    const { isLoggedIn, user } = useSelector( state => state.auth);
    const an8Logged = isLoggedIn? user.noCustomer:'---';

    const baseUrl = process.env.REACT_APP_API_URL;

    const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
    const sessionDifference = timeSessionDifference();

    const dispatch = useDispatch();
    const history = useHistory();
    
  const location = useLocation();

    const [customers, setCustomers] = useState({
        isLoading: true,
        isDisabled: true,
        data:[]
    });

    const [pendingPayment, setPendingPayment] = useState({
        isLoading: false,
        status: true
      });
    const [cashPayment, setCashPayment] = useState({
        isLoading:false,
        status:true
    })
    const [contentConcepts, setContentConcepts] = useState(['']);
    const [selectConcept, setSelectConcept] = useState("")
    const [ isDisabled, setIsDisabled] = useState(true);
    const [ isLoadingConceptsData, setIsLoadingConceptsData ] = useState(true);

    const [openModal, setOpenModal] = useState(false);

    const [ isLoadingStartAdvancePayment, setIsLoadingStartAdvancePayment ] = useState(false);

    const [dataAdvancePayment, setDataAdvancePayment] = useState([]);
    const [dataStartPayment, setDataStartPayment] = useState({})

    const validationSchema = Yup.object().shape({
        an8: Yup.string().required('cliente requerido'),
        concept: Yup.string().required('El concepto es requerido.'),
        amount: Yup.number()
                    .typeError("Solo se admiten números.")
                    .required('El importe es requerido.'),
        comment: Yup.string().required('El comentario es requerido.')
                    .max(39, 'Máximo 39 caracteres.')
                    .matches(/^[A-zÀ-ú\d\-_\s]+$/i, "Solo se admiten letras y números."),
    });

    const {
        register,
        handleSubmit,
        getValues,
        watch,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });
    const an8 = watch("an8")
    useEffect(()=>{
        setValue("concept", "")
    },[an8,setValue])
    useEffect(() => {
        PaymentService.getConcepts().then((response)=>{
            setContentConcepts(response);
            setIsDisabled(false);
            setIsLoadingConceptsData(false);
        }).catch((error)=>{
            setContentConcepts([]);
            setIsDisabled(false);
            setIsLoadingConceptsData(false);
            if(sessionDifference > Number(tokenExpired)){
                sesionExpired(dispatch, history);
              } else{
                  actionErrorConnection(error, 
                      (error.response && error.response.data) ?'No existen Conceptos de pago':'Error al recuperar concepto de pago');
              }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => {
        getCustomers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => {
        const customerActived = location.state?.customer;
        
        if(customerActived){
            setValue("an8", customerActived)
            
           
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    
    
/**
   * Recupera la lista de clientes
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Noviembre 2023
   */
  const getCustomers = () =>{

    setCustomers({
      isLoading: true,
      isDisabled: true,
      data:[]
    })

    usersService.getCustomerAssociatesByAN8(an8Logged).then((response)=>{
        let customersResponse = response;
        
      setCustomers({
        isLoading: false,
        isDisabled: false,
        data:customersResponse
      });
    }).catch((error)=>{
      console.log(error);
      setCustomers({
        isLoading: false,
        isDisabled: false,
        data:['']
      });
      
      if(sessionDifference > Number(tokenExpired)){
        sesionExpired(dispatch, history);
      } else{
        actionErrorConnection(error, 'Error al recuperar clientes.');
      }
    });
  }

  /**
   * Realiza busqueda de pago pendiente al seleccionar un an8
   * @param {object} data - estado del selector an8
   * @author alSanchez - ETE
   * @version 1.0.0 - Dociembre 2023
   */

  const onCustomerChange = (data) =>{
    if (data.target.value || (Number(data.target.value.length) !== 0)) {
        getPendingPayment(data.target.value);
        getCashPayment(data.target.value)
    }
  }

  /**
   * Recupera estado de pago pendiente por an8
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Dociembre 2023
   */
  const getCashPayment = (an8) =>{
      //Asignando el valor de isLoading como true, inicializando el proceso de obtener el servicio 
    setCashPayment({
        isLoading: true,
        status:false
    })
    PaymentService.getstatusCashPayment(an8).then((response)=>{
        setCashPayment({
            isLoading: false,
            status:response
        })

    }).catch((error)=>{
        setPendingPayment({
            isLoading: false,
            status: false
          });  
      if(sessionDifference > Number(tokenExpired)){
        sesionExpired(dispatch, history);
      } else{
        actionErrorConnection(error, 'Error al recuperar estado de pagos pendientes.');
      }
    });
  }
  
  const getPendingPayment = (an8) =>{

    setPendingPayment({
      isLoading: true,
      status: false
    })

    PaymentService.getstatusPendingPayment(an8).then((response)=>{
        setPendingPayment({
            isLoading: false,
            status: response
          })
          
    }).catch((error)=>{
        setPendingPayment({
            isLoading: false,
            status: false
          });
      if(sessionDifference > Number(tokenExpired)){
        sesionExpired(dispatch, history);
      } else{
        actionErrorConnection(error, 'Error al recuperar estado de pagos pendientes.');
      }
    });
  }

    const startServicePaiment = (data, e) => {
        e.preventDefault();

        setIsLoadingStartAdvancePayment(true);

        const an8 = getValues().an8;

        const todayDate = new Date();

        console.log(todayDate);

        const dateArray = {
            day: todayDate.getDate() < 10 ? `0${todayDate.getDate()}` : todayDate.getDate(),
            mounth: todayDate.getMonth()+1 < 10 ? `0${todayDate.getMonth()+1}` : todayDate.getMonth()+1,
            year: todayDate.getFullYear().toString().substr(-2),
            hour: todayDate.getHours() < 10 ? `0${todayDate.getHours()}` : todayDate.getHours(),
            minute: todayDate.getMinutes() < 10 ? `0${todayDate.getMinutes()}` : todayDate.getMinutes(),
            second: todayDate.getSeconds() < 10 ? `0${todayDate.getSeconds()}` : todayDate.getSeconds()
        }

        console.log(dateArray.second);
        let formatReference = "" // Asignarle formatReference un valor de string vacio
        if(selectConcept === "Contado") formatReference= "C" // Si del elemento select se selecciona el valor Contado formatReference tendra un valor de C
        else if(selectConcept === "Anticipo")  formatReference = "A" // Si del elemento select se selecciona el valor Contado formatReference tendra un valor de C
        const reference = `${formatReference}-${dateArray.day}${dateArray.mounth}${dateArray.year}-${dateArray.hour}${dateArray.minute}${dateArray.second}`.trim();

        const advancePaymentArray = {
            amount: data ? data.amount : 0,
            comment: data ? data.comment : '',
            paymentConcept: data ? data.concept : '',
            transaction: reference
        };

        setDataStartPayment(advancePaymentArray);

        PaymentService.startAdvancePayment(advancePaymentArray, an8)
        .then(()=>{

            console.log('ok');
            setIsLoadingStartAdvancePayment(false);
            handleOpenModal(reference, data);
        })
        .catch((error)=>{
            console.log(error);
            setIsLoadingStartAdvancePayment(false);

            if(error.response){

                if(sessionDifference > Number(tokenExpired)){
                    sesionExpired(dispatch, history);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al almacenar proceso de anticipo.',
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar'
                        });
                }
            } else{
                actionErrorConnection(error, 'Error al almacenar proceso de anticipo.');
            }
        });
    }

    const savePaymentRequest = (request) => {

        const an8Select = getValues().an8;

        const requestToSend = {
            account:request.mp_account,
            product:request.mp_product,
            order:request.mp_order,
            reference:request.mp_reference,
            node:request.mp_node,
            concept:request.mp_concept,
            amount:request.mp_amount,
            signature:request.mp_signature,
            customername:request.mp_customername,
            currency:request.mp_currency,
            urlsuccess:request.mp_urlsuccess,
            urlfailure:request.mp_urlfailure
        } 

        PaymentService.savePaymentRequest(requestToSend, an8Select)
            .then((response) => {
                if(!response.data){
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: `${response.message}`,
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar'
                    });
                }
            })
            .catch((error) => {
                console.log(error);

                if (error.response) {

                    if (sessionDifference > Number(tokenExpired)) {
                        sesionExpired(dispatch, history);
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al realizar guardado de solicitud.',
                            showConfirmButton: true,
                            confirmButtonText: 'Aceptar'
                        });
                    }
                } else {
                    actionErrorConnection(error, 'Error al realizar guardado de solicitud.');
                }
            });
    }
    const handleChange = (e)=>{
        let selectValue = e.target.value.split(" ").pop(); //Obtiene el nombre del metodo de pago
        
        if(selectValue === "Contado"){
            setValue("concept", e.target.value)
            if(!cashPayment.status){
                swalCustomButtons.fire({
                    title: 'Advertencia',
                    html: `<span>El cliente ${getValues().an8} no puede realizar pagos de contado </span>`,
                    icon: 'warning',
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                  });
              }
        }
        if(selectValue === "Anticipo") {
           setValue("concept", e.target.value)
            if(!pendingPayment.status){
                swalCustomButtons.fire({
                    title: 'Advertencia',
                    html: `<span>El cliente ${getValues().an8} no puede generar anticipos, cuenta con facturas pendientes </span>`,
                    icon: 'warning',
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                  });
              }
        
        }


        setSelectConcept(selectValue)
    }

    const cancelPaymentRequest = (dataStart) =>{

        const an8 = getValues().an8;

        const dataPaymentToSend = dataStart;

        PaymentService.cancelAdvancePayment(dataPaymentToSend, an8)
            .then((response) => {

                if(!response.data && response.message !== 'Proceso realizado correctamente'){
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: `${response.message}`,
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar'
                    });
                }
            })
            .catch((error) => {

                if (error.response) {

                    if (sessionDifference > Number(tokenExpired)) {
                        sesionExpired(dispatch, history);
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al terminar proceso de pago.',
                            showConfirmButton: true,
                            confirmButtonText: 'Aceptar'
                        });
                    }
                } else {
                    actionErrorConnection(error, 'Error al terminar proceso de pago.');
                }
            });
    }

    const handleOpenModal = (reference, data) => {
        
        const an8Select = getValues().an8;
        const clientName = customers.data?.find(({noCustomer})=>noCustomer === an8Select)?.name;
        const amount = data ? data.amount : 0.00;
        let dataPaymentContent = {
            mp_account: process.env.REACT_APP_MP_ACCOUNT,
            mp_product: process.env.REACT_APP_MP_PRODUCT,
            mp_order: an8Select?.trim(),
            mp_reference: reference.trim(),
            mp_node: process.env.REACT_APP_MP_NODE,
            mp_concept: process.env.REACT_APP_MP_CONCEPT,
            mp_amount: amount > 0 ?Number.parseFloat(amount).toFixed(2).trim(): 0,
            mp_signature: sha256.hmac(process.env.REACT_APP_KEY,`${an8Select?.trim()}${reference}${amount > 0 ?Number.parseFloat(amount).toFixed(2):0}`.trim()),
            mp_customername: clientName.trim(),
            mp_currency: process.env.REACT_APP_MP_CURRENCY,
            mp_urlsuccess: baseUrl + process.env.REACT_APP_MP_URLSUCCESS,
            mp_urlfailure: baseUrl + process.env.REACT_APP_MP_URLFAILURE
        };

        savePaymentRequest(dataPaymentContent);

        setDataAdvancePayment(dataPaymentContent);

        setOpenModal(true);

      };
    
    const handleCloseModal = () => {
        cancelPaymentRequest(dataStartPayment)
        setOpenModal(false);
    };
    

    const tooltipMessage = useMemo(() => {
        if (selectConcept === "Contado" && !cashPayment.status ) {
            return "El cliente no puede realizar pago de contado";
        } else if (selectConcept === "Anticipo" && !pendingPayment.status) {
            return "El cliente no puede realizar anticipos";
        } else {
            return "";
        }
    }, [selectConcept, pendingPayment.status, cashPayment.status]);
    return (
        <>
            <div className="container-fluid p-0 m-0">
                <div className="row flex-nowrap p-0 m-0">
                    <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                        <SidebarMenu/>
                    </div>
                    <div className="col p-0 ms-1 me-1">
                        <NavTopMenu />
                        <div className="container ps-3 pe-3 container-size">
                            <div className="row base-container ">
                                <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                                    <span>Contenido </span>
                                    <i className="fas fa-angle-right ms-2 me-2"></i>
                                    <span>Referencia de anticipo</span>
                                </div>
                                <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                                    <form>
                                        <div className="container p-0">
                                            <div className="row ">
                                                <div className="col-md-3">
                                                <div className="border-text-menu-title">
                                                    <span className="text-subtitle" >Pago</span>
                                                </div>
                                                </div>
                                                <div className="col-md-9 pt-5 pb-2">
                                                <div className="row">
                                                    <div className="col-md-7 mt-2 mb-2">
                                                        <TextField
                                                            select
                                                            required
                                                            id="an8"
                                                            name="an8"
                                                            label={customers.isLoading ? <div className="fa-1x"> <i className="fas fa-spinner fa-spin"></i></div> : "Num. cliente" }
                                                            variant="outlined"
                                                            size="small" 
                                                            disabled={customers.isDisabled || customers.isLoading}
                                                            fullWidth
                                                            defaultValue={location.state?.customer ? location.state?.customer : ''}
                                                            {...register('an8')}
                                                            error={errors.an8 ? true : false}
                                                            onBlur={onCustomerChange}
                                                            >
                                                                <MenuItem value="">Seleccionar cliente</MenuItem>
                                                            {customers.data.map(({noCustomer, name}) => (
                                                                <MenuItem key={noCustomer} value={noCustomer}>
                                                                {noCustomer} - {name}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>
                                                        <Typography variant="inherit" color="error">
                                                            {errors.an8?.message}
                                                        </Typography>
                                                    </div>
                                                    <div className="col-md-7 mt-2 mb-2">
                                                    <TextField
                                                        select
                                                        required
                                                        id="concept"
                                                        name="concept"
                                                        label={ isLoadingConceptsData || cashPayment.isLoading || pendingPayment.isLoading ? <div className="fa-1x"> <i className="fas fa-spinner fa-spin"></i></div> : "Seleccionar concepto"}
                                                        variant="outlined"
                                                        size="small" 
                                                        fullWidth
                                                        {...register('concept', { required: true })}
                                                        defaultValue=""
                                                        error={errors.concept ? true : false}
                                                        disabled = {isDisabled || isLoadingConceptsData || cashPayment.isLoading || pendingPayment.isLoading  }
                                                        onChange={handleChange}
                                                        value={watch("concept") || ""}
                                                        >
                                                            <MenuItem value="">Seleccionar concepto</MenuItem>
                                                        {contentConcepts.map((option, id) => (
                                                            <MenuItem disabled={cashPayment.isLoading || pendingPayment.isLoading } key={id} value={option}>
                                                            {option}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                    <Typography variant="inherit" color="error">
                                                        {errors.concept?.message}
                                                    </Typography>
                                                    </div>
                                                    <div className="col-md-7 mt-2 mb-2">
                                                    <TextField
                                                        required
                                                        id="amount"
                                                        name="amount"
                                                        label="Importe"
                                                        fullWidth
                                                        size="small"
                                                        variant="outlined"
                                                        {...register('amount')}
                                                        error={errors.amount ? true : false}
                                                        disabled = { isDisabled }
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                          }}
                                                    />
                                                    <Typography variant="inherit" color="error">
                                                            {errors.amount?.message}
                                                    </Typography>
                                                    </div>
                                                    <div className="col-md-12 mt-2 mb-2">
                                                    <TextField
                                                        required
                                                        className="w-100"
                                                        id="comment"
                                                        name="comment"
                                                        label="Comentario"
                                                        type="text"
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        multiline
                                                        rows={4}
                                                        {...register('comment')}
                                                        error={errors.comment ? true : false}
                                                        disabled = { isDisabled }
                                                    />
                                                    <Typography variant="inherit" color="error">
                                                        {errors.comment?.message}
                                                    </Typography>
                                                    </div>
                                                </div> 
                                                </div>
                                            </div>
                                            <div className="d-flex flex-row-reverse ">
                                                <div className="col-md-9 d-flex flex-row-reverse border-button-actions mt-2 pt-2">
                                                <Tooltip title={tooltipMessage } placement="top-start" arrow>
                                                    <div>
                                                        <button  
                                                        className="btn custom-btn pt-2 pb-2 ps-3 pe-3" 
                                                        onClick={ handleSubmit(startServicePaiment) }
                                                        disabled={ isLoadingStartAdvancePayment || isDisabled || (!pendingPayment.status && selectConcept ==="Anticipo") || (!cashPayment.status && selectConcept ==="Contado") }
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <span>Procesar pago</span>
                                                                <span className="pt-1 ps-2">
                                                                {
                                                                    isLoadingStartAdvancePayment
                                                                    ? <i className="fas fa-spinner fa-spin"></i>
                                                                    : <i className="fas fa-angle-right"></i>
                                                                }
                                                                </span>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </Tooltip>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    <Modal
                                        open={openModal}
                                        onClose={handleCloseModal}
                                    >
                                        <div className="custom-modal-position p-4">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-12 d-flex justify-content-center mb-4">
                                                        <span className="icon-container d-flex align-items-center justify-content-center">
                                                        <i className="fas fa-exclamation custom-icon-alert"></i>
                                                        </span>
                                                    </div>
                                                    <div className="col-12 d-flex justify-content-center mb-4">
                                                        <span className="text-modal-title">Iniciando proceso de pago...</span>
                                                    </div>
                                                    <div className="col-12 d-flex justify-content-center mb-4">
                                                        <span className="d-block text-modal">Será redireccionado al portal de pagos.</span>
                                                    </div>  
                                                </div>
                                                <div className="row ">
                                                <div className="col-12 mt-2 pt-2 d-flex justify-content-center">
                                                    <button  
                                                    className="btn custom-cancel-btn pt-1 pb-1 ps-2 pe-2 me-3" 
                                                    type="button" 
                                                    onClick={handleCloseModal}>
                                                        Cancelar
                                                    </button>
                                                    <form method="post" action={process.env.REACT_APP_MP_URL}>
                                                        <input type="hidden" name="mp_account" value={dataAdvancePayment.mp_account}/>
                                                        <input type="hidden" name="mp_order" value={dataAdvancePayment.mp_order}/>
                                                        <input type="hidden" name="mp_reference" value={dataAdvancePayment.mp_reference}/>
                                                        <input type="hidden" name="mp_customername" value={dataAdvancePayment.mp_customername}/>
                                                        <input type="hidden" name="mp_product" value={dataAdvancePayment.mp_product}/>
                                                        <input type="hidden" name="mp_node" value={dataAdvancePayment.mp_node}/>
                                                        <input type="hidden" name="mp_concept" value={dataAdvancePayment.mp_concept}/>
                                                        <input type="hidden" name="mp_amount" value={dataAdvancePayment.mp_amount}/>
                                                        <input type="hidden" name="mp_currency" value={dataAdvancePayment.mp_currency}/>
                                                        <input type="hidden" name="mp_signature" value={dataAdvancePayment.mp_signature}/>
                                                        <input type="hidden" name="mp_urlsuccess" value={dataAdvancePayment.mp_urlsuccess}/>
                                                        <input type="hidden" name="mp_urlfailure" value={dataAdvancePayment.mp_urlfailure}/>
                                                        <button 
                                                            className="btn custom-btn pt-1 pb-2 ps-3 pe-3" 
                                                            type="submit">
                                                            <div className="btn custom-btn pt-1 pb-1 ps-2 pe-2">
                                                                <span>Aceptar</span>
                                                            </div>
                                                        </button>
                                                    </form>
                                                </div>
                                                </div>                  
                                            </div>
                                        </div>
                                    </Modal>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
};